import { Stack, Typography } from '@mui/material';
import { type PropsWithChildren, useRef, useState } from 'react';

import { Icon, CheckboxFilter } from '@hapvida/hapvida-core-components';

import newUseFilterParams from '@hapvida/hapvida-core-components/src/hooks/newUseFilterParams';

import {
  USER_STATUS_COLOR,
  USER_STATUS_ICON_NAME,
  USER_STATUS_NAME,
  UserStatusEnum,
} from '@constants';

import type {
  FiltersDrawerButtonProps,
  IFilterOptions,
  TFilterValue,
} from '../types';
import { FilterDrawerBase } from '../FilterDrawerBase';
import { formatObjectToFilterUrl } from '../FilterDrawerBase/utils/formatObjectToFilterUrl';

export function NewFilterDrawerUsersBackoffice({
  subtitle,
  title,
  ...buttonProps
}: PropsWithChildren<FiltersDrawerButtonProps>) {
  const [visibleDrawer, setVisibleDrawer] = useState(false);
  const { changeMultiple } = newUseFilterParams({});

  const handleToggleDrawer = () => {
    setVisibleDrawer(!visibleDrawer);
  };

  const refs: IFilterOptions = {
    status: useRef(null),
    profileId: useRef(null),
  };

  const handleApplyAll = () => {
    let inputsValueObj: TFilterValue = {};

    Object.keys(refs).forEach(key => {
      const ref = refs[key];

      if (ref?.current) {
        inputsValueObj = { ...inputsValueObj, ...ref.current?.filterValue };
      }
    });

    const objectFilterValues = { ...inputsValueObj };

    changeMultiple(formatObjectToFilterUrl(objectFilterValues));
    handleToggleDrawer();
  };

  const userStatusFilters = Object.values(UserStatusEnum).map(userStatus => {
    const content = (
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Icon
          name={USER_STATUS_ICON_NAME[userStatus]}
          color={USER_STATUS_COLOR[userStatus]}
          size={16}
        />
        <Typography variant="text" color={USER_STATUS_COLOR[userStatus]}>
          {USER_STATUS_NAME[userStatus]}
        </Typography>
      </Stack>
    );

    return {
      label: USER_STATUS_NAME[userStatus],
      value: userStatus,
      content,
    };
  });

  return (
    <FilterDrawerBase
      title={title}
      subtitle={subtitle}
      handleApplyAll={handleApplyAll}
      {...buttonProps}
    >
      <CheckboxFilter
        filters={userStatusFilters}
        title="Status dos usuários"
        name="status"
        ref={refs.status}
        isMultiple={false}
      />
    </FilterDrawerBase>
  );
}
